import React from 'react'
import './HomeHero.css'
import {ReactComponent as ArrowWhite} from '../../assets/arrowRightWhite.svg'
import {ReactComponent as ArrowBlack} from '../../assets/arrowRightBlack.svg'
//import {ReactComponent as Ellipse} from '../../assets/Ellipse.svg'

function HomeHero() {
    return (
        <div className="homeHeroWrapper">
            <div className="homeHero">
                <div className="homeHeroMain">
                    <h1 className="homeHeroSubTitle">
                        Leading <span style={{color:"#00D563"}}>startups</span> through the <span style={{color:"#00D563"}}>experience</span> .
                    </h1>
                </div>
                <div className="homeHeroSub">
                    <h3 className="homeHeroSubContent">
                        Creamos tu startup. Ideación, construcción y producción.
                    </h3>
                </div>
                <div className="homeHeroBtns">
                    <button className="homeHeroBtn">
                        <p className="homeHeroBtnContent">¿Cómo crear tu  startup?<ArrowWhite/></p>
                    </button>
                    <a className= "homeHeroMore" href="/">
                       Contactar con el equipoo de ventas<ArrowBlack />
                    </a>
                </div>
             
            </div>
            


        </div>
    )
}

export default HomeHero